export default "__VITE_ASSET__DSHDolQb__"